export const formatKilolitres = (quantity: number) => {
  return `${(quantity / 1000).toLocaleString()} ML`;
};
